import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import { Alert, Card, CardContent } from '@guildeducationinc/recess';
import DeleteOutlineIcon from '@guildeducationinc/recess/icons/DeleteOutlineIcon';
import EditIcon from '@guildeducationinc/recess/icons/EditIcon';
import { AdminTopNav } from '@src/components/Admin/AdminTopNav';
import { DELETE_MACRO } from '@src/graphql/queries/macro';
import { useAuth } from '@src/hooks/useAuth';
import { useMacros } from '@src/hooks/useMacros';
import { Confirm, DataTable, SearchFilterBar, TrackableButton, useAlert, useLocale, useSessionState, } from 'pe-core-frontend';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
export const Macros = () => {
    const { isClaimsProcessor } = useAuth();
    const { t } = useLocale();
    const { showAlert } = useAlert();
    const navigate = useNavigate();
    const [searchText, setSearchText] = useSessionState('macrosSearch', '');
    const { macros, loading, error, page, pageSize, setPage, setPageSize, total, orderBy, orderByDir, setOrderBy, setOrderByDir, refetch, } = useMacros({
        searchText,
    });
    const [deleteMacro] = useMutation(DELETE_MACRO);
    const [macroToDelete, setMacroToDelete] = useState(null);
    const handleAdd = () => {
        navigate('/admin/macros/new');
    };
    const handleDelete = async () => {
        if (macroToDelete) {
            try {
                await deleteMacro({
                    variables: {
                        id: macroToDelete.id,
                    },
                });
                showAlert(t('Macro deleted'));
                setMacroToDelete(null);
                await refetch();
            }
            catch (e) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                showAlert(e.message, 'error');
            }
        }
    };
    const handleSortModelChange = (sortModel) => {
        if (sortModel && sortModel.length > 0) {
            const sort = sortModel[0];
            setOrderBy(sort.field);
            setOrderByDir(sort.sort);
        }
        else {
            setOrderBy(null);
            setOrderByDir(null);
        }
    };
    return (_jsxs("div", { children: [_jsx(AdminTopNav, { title: t('Macros'), searchFilterActions: _jsx(SearchFilterBar, { enableSearch: true, searchText: searchText, onSearchChange: setSearchText, searchPlaceholder: t('Search by Title') }), actions: isClaimsProcessor && (_jsx("div", { children: _jsx(TrackableButton, { btnType: 'mui', enText: 'Add Macro', tag: 'header', color: 'primary', variant: 'contained', type: 'button', className: 'button button--primary margin--bottom_16', onClick: handleAdd, children: t('Add') }) })) }), _jsx("div", { children: _jsx(Card, { children: _jsxs(CardContent, { children: [error && (_jsx(Alert, { display: true, hideClose: true, type: 'danger', children: error.message })), _jsx(DataTable, { disableRowSelectionOnClick: true, disableColumnMenu: true, rows: macros, loading: loading, pageSizeOptions: [10, 25], paginationMode: 'server', paginationModel: { page: page - 1, pageSize }, onPaginationModelChange: pagination => {
                                    setPage(pagination.page + 1);
                                    setPageSize(pagination.pageSize);
                                }, onSortModelChange: handleSortModelChange, sortModel: [{ field: orderBy ?? 'name', sort: orderByDir }], rowCount: total, getRowHeight: params => (params.model.clients.length > 2 ? 'auto' : undefined), columns: [
                                    {
                                        field: 'category',
                                        headerName: t('Category'),
                                        flex: 0.2,
                                    },
                                    {
                                        field: 'title',
                                        headerName: t('Title'),
                                        flex: 0.4,
                                    },
                                    {
                                        field: 'clients',
                                        headerName: 'Clients',
                                        flex: 0.2,
                                        renderCell: ({ row, value }) => row.isGeneric
                                            ? t('All')
                                            : value
                                                .map(c => c.name)
                                                .sort()
                                                .join(', '),
                                    },
                                    {
                                        field: 'actions',
                                        headerName: t('Actions'),
                                        width: 100,
                                        renderCell: ({ row }) => (_jsxs("div", { children: [_jsx(TrackableButton, { btnType: 'icon', enText: 'Edit', tag: `macro_${row.id}`, appearance: 'minimal', label: t('Edit'), icon: _jsx(EditIcon, { size: 20 }), onClick: () => {
                                                        navigate(`/admin/macros/${row.id}`);
                                                    } }), _jsx(TrackableButton, { btnType: 'icon', enText: 'Delete', tag: `macro_${row.id}`, label: t('Delete'), appearance: 'minimal', icon: _jsx(DeleteOutlineIcon, { size: 20 }), onClick: () => setMacroToDelete(row) })] })),
                                    },
                                ] })] }) }) }), macroToDelete && (_jsx(Confirm, { message: t("Are you sure you want to delete '{name}'?", {
                    values: { name: macroToDelete.title },
                }), onConfirm: handleDelete, onCancel: () => setMacroToDelete(null) }))] }));
};
